import { CHCPlanFinderIdCard } from './plan-finder-id-card.component.js';
export { CHCPlanFinderIdCard };

customElements.define('chcapp-plan-finder-id-card', CHCPlanFinderIdCard);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-plan-finder-id-card': CHCPlanFinderIdCard;
  }
}
